export default {
	about_the_course: 'About the course',
	activity_plural: 'Activities',
	activity: 'Activity',
	attempts: 'Tentativas',
	block_general_test: "'Block' General Test",
	block_test: "'Block' Test",
	blocked: 'Blocked',
	class_plural: 'Lessons',
	class: 'Lesson',
	classes: 'Lessons',
	comment: 'Comment',
	congratulations: 'Congratulations!',
	continue: 'In progress',
	conventional_test: "'Conventional' Test",
	discussions_about_this_course: 'Discussions about this course',
	doubts: 'Doubts?',
	end_quiz: 'End Quiz',
	enroll: 'Enroll',
	enrolled: 'Enrolled',
	enrollement_type: 'Type of enrollment',
	evaluated_quiz: 'Evaluated Quiz',
	finish_test: 'Finish',
	flash: 'Flash',
	html: 'HTML',
	if_you_are_not_approved_within_the_available_attempts_you_will_have_your_progress_restarted:
		'If you are not approved within the available attempts you will have your progress restarted.',
	if_you_fail_the_available_attempts_you_will_be_blocked_in_this_training:
		'If you fail the available attempts, you will be blocked in this training.',
	if_you_pass_you_can_use_the_remaining_attempts_to_try_to_improve_your_grade:
		'If you pass, you can use the remaining attempts to try to improve your grade.',
	improved: 'Improved',
	in_this_course: 'in this course',
	keep_trying: 'Keep trying.',
	loading_courses: 'Loading courses',
	mandatory: 'Mandatory',
	maximum_attempts: 'Maximum Attempts',
	minimum_to_pass: 'Minimum to Pass',
	next_question: 'Next',
	previous_question: "Previous",
	no_courses_are_available_at_the_moment: 'No courses are currently available',
	no_courses_are_available_with_the_selected_filter:
		'There are no courses available for the selected filter',
	not_started: 'Not Started',
	number_of_questions: 'Number of questions',
	of_attempts: '{qty_attempted} of {maximum_attempts} attempts',
	of_questions: '{minimum_score} of {qty_questions} questions',
	once_you_start_the_test_you_should_not_change_activity_leave_or_refresh_the_page:
		'When starting the test you should not change your activity, leave or update the page.',
	one_attempt: 'One attempt',
	overview: 'Overview',
	powerpoint: 'PowerPoint',
	presentation: 'Presentation',
	previous_results: 'Previous Results',
	question_plural: 'Questions',
	question: 'Question',
	reproved: 'Reproved',
	restart_general_test: "'Restart' General Test",
	restart_test: "'Reset' Test",
	restart_training: 'Restart training',
	restarted: 'Restarted',
	scorm: 'Activity',
	see_previous_results: 'See previous results',
	see_results: 'See results',
	see_answers: "See answers",
	slideshare: 'Slideshare',
	start_quiz: 'Start Quiz',
	start_test: 'Start Test',
	start: 'Start',
	support_material_preview: 'Support Material Preview',
	support_materials: 'Support Materials',
	test_performance: 'Test performance',
	thank_you_for_taking_the_quiz: 'Thank you for taking the quiz',
	that_was_close: 'That was close!',
	the_result_of_this_quiz_will_not_influence_the_final_result_of_your_training:
		'The result of this quiz will not influence the final result of your training.',
	time_left: 'Time left',
	time_to_finish: 'Time to Finish',
	unenroll: 'Unenroll',
	unevaluated_quiz: 'Unevaluated Quiz',
	unlimited: 'Unlimited',
	until_approval: 'Until approval',
	video: 'Video',
	view_history: 'view history',
	when_starting_the_quiz_you_should_not_change_your_activity_leave_or_update_the_page:
		'When starting the quiz you should not change your activity, leave or update the page.',
	you_are_allowed_to_take_this_test_how_many_times_you_like_until_you_reach_the_minimum_score_to_pass:
		'You can take this test as many times as you like until you reach the minimum score to pass.',
	you_can_take_this_quiz_as_many_times_as_needed_and_you_will_need_to_get_out_of_questions_to_pass:
		'You can take this quiz as many times as needed and you will need to get {minimum_score} out of {qty_questions} questions to pass.',
	you_can_take_this_quiz_only_once_to_answer_as_many_questions_as_possible:
		'You can take this quiz only once to answer as many questions as possible.',
	you_can_take_this_test_only_once_with_a_timeout_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test:
		'You can take this test only once with a {time_to_answer} timeout to reach the minimum score to pass. You will need to get {minimum_score} out of {qty_questions} questions to pass this test.',
	you_can_take_this_test_up_to_times_to_reach_the_minimum_score_to_pass_you_will_need_to_get_out_of_questions_to_pass_this_test:
		'You can take this test up to {maximum_attempts} times to reach the minimum score to pass. You will need to get {minimum_score} out of {qty_questions} questions to pass this test.',
	you_got_out_of_questions_right_success_rate_and_you_showed_that_you_understand_a_lot_keep_it_up_and_show_that_you_are_the_one_who_dominates_this_subject:
		'You got {score} out of {questions} questions ({percent}%) and showed that you understand a lot! Keep it up and show that you are the one who dominates this subject!',
	you_got_out_of_questions_successful_and_you_didnt_reach_the_minimum_score_to_pass:
		'You hit {score} out of {questions} ({percent}% of achievement) and did not reach the minimum passing grade ({minimum_score}% of achievement).',
	you_got_out_of_success: 'You got {score} out of {questions} ({percent}% success).',
	you_have_already_answered_this_test_times_and_have_attempt_left:
		'You have already completed this test {qty_attempted} times and you have {attempts_left} remaining.',
	you_have_been_blocked_in_this_course_and_will_not_receive_a_certificate:
		'You have been blocked in this course and will not receive a certificate',
	you_have_been_blocked_in_this_training_and_will_not_receive_a_certificate_you_can_still_finish_the_other_available_activities:
		'You have been blocked in this training and will not receive a certificate. You can still finish the other available activities.',
	you_have_been_blocked: 'You have been blocked',
	you_have_only_one_attempt_to_pass_and_will_be_blocked_from_this_training_if_you_fail:
		'You have only one attempt to pass and will be blocked from this training if you fail.',
	you_have_only_one_attempt_to_pass_and_will_have_your_progress_restarted_in_this_training_if_you_fail:
		'You have only one attempt to pass and will have your progress restarted in this training if you fail.',
	you_need_to_enroll_before_starting_this_content:
		'You need to enroll before starting this content',
	you_need_to_enroll_before_starting_this_course:
		'You need to enroll before you starting this course',
	you_need_to_finish_another_course_before_starting_this:
		'You need to finish another course before starting this',
	you_need_to_get_of_questions_right_to_be_approved:
		'You need to get {minimum_score} out of {qty_questions} questions to pass this test.',
	your_progress_has_been_restarted_and_you_will_need_to_redo_all_activities_in_this_training_to_receive_the_certificate:
		'Your progress has been restarted and you will need to redo all activities in this training to receive the certificate.',
	your_progress_has_been_restarted: 'Your progress has been restarted',
	your_result: 'Your Result',
	your_status: 'Your Status',
	training_in_progress: 'Course being developed by the manager',
	video_issue_ios_message: 'Having trouble watching the video? No worries! Tap the button below to open it in your phone\'s browser.',
	watch_in_browser: 'Watch in browser',
}
